"use strict";

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require("classnames");

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Checkbox = function Checkbox(_ref) {
  var _classnames;

  var id = _ref.id,
      focus = _ref.focus,
      label = _ref.label,
      children = _ref.children,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? "checkbox" : _ref$type,
      readOnly = _ref.readOnly,
      className = _ref.className,
      indeterminate = _ref.indeterminate,
      flat = _ref.flat,
      meta = _ref.meta,
      boxed = _ref.boxed,
      error = _ref.error,
      props = _objectWithoutProperties(_ref, ["id", "focus", "label", "children", "type", "readOnly", "className", "indeterminate", "flat", "meta", "boxed", "error"]);

  var prefixCls = type;
  var inputCls = prefixCls + "__input";
  var checkCls = prefixCls + "__check";
  var labelCls = prefixCls + "__label";

  var componentCls = (0, _classnames3.default)(prefixCls, className);

  var checkComponentCls = (0, _classnames3.default)((_classnames = {}, _classnames[checkCls + "--checked"] = readOnly && (props.checked || props.defaultChecked), _classnames[checkCls + "--readonly"] = readOnly, _classnames[checkCls + "--indeterminate"] = indeterminate, _classnames[checkCls + "--focus"] = focus, _classnames), checkCls);

  return _react2.default.createElement(
    "label",
    { htmlFor: id, className: componentCls },
    readOnly ? null : _react2.default.createElement("input", _extends({
      id: id,
      className: inputCls,
      type: type
    }, props, {
      ref: function ref(input) {
        if (input) {
          input.indeterminate = indeterminate;
        }
      }
    })),
    _react2.default.createElement("div", { className: checkComponentCls }),
    _react2.default.createElement(
      "div",
      { className: labelCls },
      label || children
    )
  );
};

exports.default = Checkbox;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/lib/components/checkbox/checkbox.js
// module id = 1353
// module chunks = 249